<template>
  <router-view />
  <SnackbarItem />
</template>

<style lang="scss">
@import "@/assets/scss/all";
</style>

<script setup>
import SnackbarItem from "@/components/SnackbarItem.vue";

//Stop error resizeObserver
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = self;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const _ = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    callback = debounce(callback, 20);
    super(callback);
  }
};
</script>
